import {Component, OnInit, Input } from '@angular/core';
import { NumericTextboxModel } from '../numeric-textbox.model';
import { FORMAT_NUMBER } from 'src/app/app.models';
import { AbstractWorkflowResultComponent } from '../../@core/abstract-workflow-result.component';

@Component({
    selector: 'abw-numeric-textbox-result',
    templateUrl: './numeric-textbox-result.component.html',
    styleUrls: ['./numeric-textbox-result.component.scss']
})
export class NumericTextboxResultComponent extends AbstractWorkflowResultComponent<NumericTextboxModel> {
    FORMAT_NUMBER = FORMAT_NUMBER;
}